/* eslint-disable jsx-a11y/anchor-is-valid */
import { globalVariables } from "helper/globalVariables";
import { DEFAULT_DATE_FORMAT } from "helper/utility";
import moment from "moment";
import { useMediaQuery } from "react-responsive";

export const UserDetailCard = ({ userDetail }) => {
  const isSmallMobile = useMediaQuery({ query: "(max-width: 320px)" });

  return (
    <div class={`bg-white ${isSmallMobile ? "w-70 pb-2" : "w-80"} h-[450px] `}>
      <div class="flex justify-start flex-col mt-5 pb-3">
        <div className="flex flex-col mb-4">
          <span className="text-xs text-gray-600">{globalVariables.name}</span>
          <span className="text-md">{userDetail.name}</span>
        </div>
        <div className="flex flex-col mb-4">
          <span className="text-xs text-gray-600">{globalVariables.date}</span>
          <span className="text-md">
            {moment(userDetail.date).format(DEFAULT_DATE_FORMAT)}
          </span>
        </div>
        <div className="flex flex-col mb-4">
          <span className="text-xs text-gray-600">
            {globalVariables.location}
          </span>
          <span className="text-md">{userDetail.location}</span>
        </div>
        <div className="flex flex-col mb-4">
          <span className="text-xs text-gray-600">{globalVariables.level}</span>
          <span className="text-md">{userDetail.level}</span>
        </div>

        <div className="flex flex-col mb-4">
          <span className="text-xs text-gray-600">
            {globalVariables.dogEnteredInTrail}
          </span>
          <span className="text-md">{userDetail.noOfEntries}</span>
        </div>
      </div>
    </div>
  );
};
